import { schemas } from "@card-data/generated/api.client";

import { CreditCardInput } from "../types";

export const TD_CARDS: Array<CreditCardInput> = [
  {
    cardId: "0820b7c9725a7adf52e4721b6f57affa",
    name: "Cash",
    issuer: schemas.IssuersEnum.enum.TD,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.USD,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://www.td.com/us/en/personal-banking/credit-cards/cash-credit-card",
    imageUrl: "/images/td/cash.png",
    credits: [],
    offers: [
      {
        amount: [{ amount: 200, currency: schemas.CurrenciesEnum.enum.USD }],
        spend: 1000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 200, currency: schemas.CurrenciesEnum.enum.USD }],
        spend: 1000,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "52c02922a11a375b12a91d06683b9dd1",
    name: "Double Up",
    issuer: schemas.IssuersEnum.enum.TD,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.USD,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 2,
    url: "https://www.td.com/us/en/personal-banking/credit-cards/double-up-credit-card",
    imageUrl: "/images/td/double-up.png",
    credits: [],
    offers: [
      {
        amount: [{ amount: 200, currency: schemas.CurrenciesEnum.enum.USD }],
        spend: 500,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 200, currency: schemas.CurrenciesEnum.enum.USD }],
        spend: 1500,
        days: 90,
        credits: [],
        expiration: "2026-08-05",
      },
    ],
  },
];
